import { render, staticRenderFns } from "./VoteResultInfo.vue?vue&type=template&id=001267f2&scoped=true"
import script from "./VoteResultInfo.vue?vue&type=script&lang=js"
export * from "./VoteResultInfo.vue?vue&type=script&lang=js"
import style0 from "./VoteResultInfo.vue?vue&type=style&index=0&id=001267f2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "001267f2",
  null
  
)

export default component.exports